package uk.co.nickthecoder.kyd

import uk.co.nickthecoder.glok.util.log

/**
 *
 */
open class Stage(

    val name: String

) : ActorParent {

    var playing = false

    protected val mutableActors = mutableListOf<Actor>()

    val actors get() : List<Actor> = mutableActors

    override val children: List<Actor> get() = actors


    override fun removeActor(actor: Actor) {
        mutableActors.remove(actor)
        try {
            actor.behaviour.onExitedStage(actor, this)
        } catch (e: Exception) {
            log.severe("Behaviour ${actor.behaviour} threw during onExitedStage")
            log.severe(e)
        }
    }

    override fun addActor(index: Int, actor: Actor) {
        if (actor.parent !== this) {
            actor.parent.removeActor(actor)
        }
        actor.parent = this
        mutableActors.add(index, actor)
        if (playing) {
            try {
                actor.behaviour.onEnteredStage(actor)
            } catch (e: Exception) {
                log.severe("Behaviour ${actor.behaviour} threw during onEnteredStage")
                log.severe(e)
            }
        }
    }

    fun addAll(actors: Collection<Actor>) {
        mutableActors.addAll(actors)
        for (actor in actors) {
            actor.behaviour.onEnteredStage(actor)
        }
    }

    fun removeAll(actors: Collection<Actor>) {
        mutableActors.removeAll(actors)
        for (actor in actors) {
            actor.behaviour.onExitedStage(actor, this)
        }
    }

    /**
     * Gives subclasses an opportunity to re-order the actors.
     * e.g. [ZOrderStage] sorts the actors by [Actor.zOrder].
     */
    open fun prepareDraw() {}

}
